import React from 'react';
import { shallowEqual } from 'react-redux';
import { Box, Label, Select } from '@apia/theme';
import { rtDebug } from '..';
import { useAppSelector } from '../../../../../hooks/hooks';
import useRenderDebug from '../../../../../hooks/useRenderDebug';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import { TResponsiveTableSortValue } from '../types';

const Sort = ({ tableName }: { tableName?: string }) => {
  const { name, onSortChange } = useResponsiveTableContext(tableName);

  const columns = useAppSelector((global) => {
    return global.responsiveTableSlice[name]?.columns;
  }, shallowEqual);

  useRenderDebug(rtDebug.filters.sort, 'Sort.tsx', {
    name,
    onSortChange,
    columns,
  });

  return (
    <>
      {columns?.map((column, columnIndex) => {
        return column.showAsAdditional ||
          column.allowSorting === false ? null : (
          <Label key={column.name}>
            <Box as="span">
              {column.label !== '' ? column.label : column.title}
            </Box>
            <Box>
              <Select
                value={
                  column.currentSorting === null ? '' : column.currentSorting
                }
                onChange={(ev) => {
                  console.log({ columnIndex });
                  if (onSortChange)
                    onSortChange({
                      columnIndex,
                      column,
                      name: column.name,
                      sortValue:
                        ev.target.value === ''
                          ? null
                          : (ev.target.value as TResponsiveTableSortValue),
                    });
                }}
              >
                <option value="" />
                <option value="A">{window.ORDER_ASC_LABEL}</option>
                <option value="D">{window.ORDER_DESC_LABEL}</option>
              </Select>
            </Box>
          </Label>
        );
      })}
    </>
  );
};

export default React.memo(Sort);
